// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `i {
  align-self: flex-end;
  margin: 1rem;
}

input {
  background-color: #f8f8f8;
  border-radius: 8px;
  width: -webkit-fill-available;
  margin: 1rem;
  font-weight: bold;
}

ion-button {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  align-self: center;
  margin: 1rem;
}

div {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pnr-code/pnr-code.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,YAAA;AACF;;AACA;EACE,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,iBAAA;AAEF;;AAAA;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,YAAA;AAGF;;AADA;EACE,aAAA;EACA,sBAAA;AAIF","sourcesContent":["i {\n  align-self: flex-end;\n  margin: 1rem;\n}\ninput {\n  background-color: #f8f8f8;\n  border-radius: 8px;\n  width: -webkit-fill-available;\n  margin: 1rem;\n  font-weight: bold;\n}\nion-button {\n  width: max-content;\n  align-self: center;\n  margin: 1rem;\n}\ndiv {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
